import { PremiumSummaryInfo } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

export const useFetchPremiumSummary = () => {
  const fetchPremiumSummary = async () => {
    const res = await medicareApiClient.premiumsApi.getPremiumSummary()
    return res.data
  }

  return useQuery<PremiumSummaryInfo | undefined>(
    'premiumSummary',
    fetchPremiumSummary,
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  )
}
